import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { initI18n } from './translations/i18n';
import { StoreProvider } from './store';
import { Layout } from './components/layout/layout';
import { NotFoundPage } from './components/not-found-page/not-found-page';
import { RatesPage } from './components/rates-page/rates-page';
import { RedirectPage } from './components/redirect-page/redirect-page';

function App() {
  initI18n();

  return (
    <StoreProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/:tenantId/:shortName" element={<RatesPage />} />
            <Route path="/rates/:fileName?" element={<RedirectPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
